import { apiUrl } from '../../../settings'

export const AuthorGuidelineUrl = () => {
  return apiUrl + '/authorGuideLine'
}
